import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Group } from '../../models/group';

@Component({
  selector: 'app-group-manager',
  templateUrl: './group-manager.component.html',
  styleUrls: ['./group-manager.component.css']
})
export class GroupManagerComponent implements OnInit {
  @Input() groups: Group[] = [];
  @Input() userGroups: Group[];
  @Output() changes: EventEmitter<boolean> = new EventEmitter();
  selected: number;

  constructor() { }

  ngOnInit() {
  }

  onAdd() {
    const i = this.groups.findIndex(n => n.Precedence === this.selected);
    const grp = this.groups.find(n => n.Precedence === this.selected);
    this.userGroups.push(grp);
    this.groups.splice(i, 1);
    this.selected = 0;
    this.changes.emit(true);
  }

  onRemove(event: Group) {
    const i = this.userGroups.findIndex(n => n.Precedence === event.Precedence);
    this.userGroups.splice(i, 1);
    this.groups.push(event);
    this.groups.sort((a, b) => a.Precedence - b.Precedence);
    this.changes.emit(true);
  }
}
